type Environemnt = {
  VITE_API_URL: string;
  VITE_APP_TITLE: string;
  VITE_ENV: string;
  VITE_IDSYSDBCOMPANY: string;
  VITE_SENTRY_DSN: string;
};

// eslint-disable-next-line no-underscore-dangle, @typescript-eslint/no-explicit-any
// const windowEnv = (window as any).__env__;

const env: Readonly<Environemnt> = {
  VITE_ENV: import.meta.env.VITE_ENV,
  VITE_APP_TITLE: import.meta.env.VITE_APP_TITLE,
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_IDSYSDBCOMPANY: import.meta.env.VITE_IDSYSDBCOMPANY,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
};

export default env;
